import { createAsyncThunk } from "@reduxjs/toolkit";
import { IUserView } from "../../modules/users/models/IUserView";
import { UserService } from "../../modules/users/services/userService";
import { IAddressView } from "../../modules/users/models/IAddressView";
import { AuthUtil } from "../../utils/AuthUtil";

/**
 * Register a User
 */
export const registerUserAction: any = createAsyncThunk(
  "users/registerUserAction",
  async (
    payload: { user: IUserView },
    { rejectWithValue }
  ): Promise<{ data: null; msg: string; status: string } | any> => {
    try {
      const { user } = payload;
      const response = await UserService.registerUser(user);
      return response.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * User Login
 */
export const loginUserAction: any = createAsyncThunk(
  "users/loginUserAction",
  async (
    payload: { user: IUserView },
    { rejectWithValue }
  ): Promise<{ data: IUserView; msg: string; token: string; status: string } | any> => {
    try {
      const { user } = payload;
      const response = await UserService.loginUser(user);
      return response.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Get User's Data
 */
export const getUserDataAction: any = createAsyncThunk(
  "users/getUserDataAction",
  async (
    payload: {},
    { rejectWithValue }
  ): Promise<{ data: IUserView; msg: string; status: string } | any> => {
    try {
      //PRIVATE REQUEST
      if (AuthUtil.setTokenToRequestHeader()) {
        const response = await UserService.getUserData();
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Update Profile Picture
 */
export const updateProfilePicAction: any = createAsyncThunk(
  "users/updateProfilePicAction",
  async (
    payload: { imageUrl: string },
    { rejectWithValue }
  ): Promise<{  data: IUserView; msg: string; status: string  } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { imageUrl } = payload;
        const response = await UserService.updateProfilePic(imageUrl);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Change the password
 */
export const changePasswordAction: any = createAsyncThunk(
  "users/changePasswordAction",
  async (
    payload: { password: string },
    { rejectWithValue }
  ): Promise<{ data: IUserView; msg: string; status: string } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { password } = payload;
        const response = await UserService.changePassword(password);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Get All Users
 */
export const getAllUsersAction: any = createAsyncThunk(
  "users/getAllUsersAction",
  async (
    payload: { },
    { rejectWithValue }
  ): Promise<{ data: IUserView[]; msg: string; status: string } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const response = await UserService.getAllUsersData();
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Update User's Role
 */
export const updateUserRoleAction = createAsyncThunk(
  "users/updateUserRoleAction",
  async (
    payload: { user: IUserView, userId: string },
    { rejectWithValue }
  ): Promise<{ data: IUserView; msg: string; status: string } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { user, userId } = payload;
        const response = await UserService.udpateUserRole(user, userId);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);



/**
 * Delete a User
 */
export const deleteUserAction: any = createAsyncThunk(
  "products/deleteUserAction",
  async (
    payload: { userId: string },
    { rejectWithValue }
  ): Promise<{ data: IUserView; msg: string; status: string } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { userId } = payload;
        const response = await UserService.deleteUser(userId);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);



/**
 * Create New Address
 */
export const createNewAddressAction: any = createAsyncThunk(
  "users/createNewAddressAction",
  async (
    payload: { address: IAddressView },
    { rejectWithValue }
  ): Promise<{ status: string; msg: string; data: IAddressView } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { address } = payload;
        const response = await UserService.createNewAddress(address);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Update Address
 */
export const updateAddressAction: any = createAsyncThunk(
  "users/updateAddressAction",
  async (
    payload: { address: IAddressView; addressId: string },
    { rejectWithValue }
  ): Promise<{ status: string; msg: string; data: IAddressView } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { address, addressId } = payload;
        const response = await UserService.updateAddress(address, addressId);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Get Address
 */
export const getAddressAction: any = createAsyncThunk(
  "users/getAddressAction",
  async (
    payload: {},
    { rejectWithValue }
  ): Promise<{ status: string; msg: string; data: IAddressView } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const response = await UserService.getAddressInfo();
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Delete Address
 */
export const deleteAddressAction: any = createAsyncThunk(
  "users/deleteAddressAction",
  async (
    payload: { addressId: string },
    { rejectWithValue }
  ): Promise<{ status: string; msg: string; data: IAddressView } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { addressId } = payload;
        const response = await UserService.deleteAddress(addressId);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
